import { string } from 'yup';

const rule = {
	name: 'containsAtLeastOneLetter',
	method ({ message } = { message: 'Your password must contain at least one letter' }) {

		return this.test('containsAtLeastOneLetter', message, function (value) {

			const { path, createError } = this;
			return /[a-zA-Z]/.test(value) || createError({ path, message });

		});

	},
	schemaType: string
};

export default rule;
